import { localhostTenant } from './localhost-tenant';

export const domainMapping = [
  {
    domain: '195.15.215.220',
    // NOTE set VUE_APP_FORCE_TENANT_ALIAS=true in local environments
    alias: !process.env.VUE_APP_FORCE_TENANT_ALIAS ? null : localhostTenant,
  },
  {
    domain: 'localhost',
    // NOTE set VUE_APP_FORCE_TENANT_ALIAS=true in local environments
    alias: !process.env.VUE_APP_FORCE_TENANT_ALIAS ? null : localhostTenant,
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_MYAWBB || 'myawbb.be',
    alias: 'myawbb',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_FRASNES || 'sportfrasnes.com',
    alias: 'sports-collines-frasnes',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_BAINS_BRUXELLES || 'bainbadbxl.be',
    alias: 'bains-de-bruxelles',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_MAISON_DES_SPORTS || 'maisondessportsbla.be',
    alias: 'maison-des-sports',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_BRAINE_LALLEUD || 'sportbrainelalleud.be',
    alias: 'braine-lalleud',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_TUBIZE || 'rdi-tubize.be',
    alias: 'rdi-tubize',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_SPRIMONTSPORT || 'sprimontsport.be',
    alias: 'rca-sprimont',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_SPORTBXL || 'sport-bxl.be',
    alias: 'sportbruxelles',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_RCAF || 'rcaf.be',
    alias: 'csa-fernelmont',
  },
  {
    domain:
      process.env.VUE_APP_DOMAIN_MAPPING_INSTITUT_VIERGEFIDELE || 'institutdelaviergefidele.be',
    alias: 'vf-fondamental',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_RCA_LA_BRUYERE || 'rca.labruyere.be',
    alias: 'cs-labruyere',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_RCA_ARLON || 'rca-arlon.be',
    alias: 'rca-arlon',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_LONGCHAMPSWIMMINGCLUB || 'longchampswimmingclub.be',
    alias: 'longchamp-int-swimmingclub',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_VAUX_SUR_SURE || 'centresportifvss.be',
    alias: 'commune-vaux-sur-sure',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_RCA_HAMOIR || 'centresportif.hamoir.be',
    alias: 'hamoir-sport',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_RCA_FLERON || 'fleronsport.be',
    alias: 'fleronsport',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_IXELLOIS || 'xlsports.be',
    alias: 'xlsports',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_DISON || 'asbljs-cslidison.com',
    alias: 'dison',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_DISON || 'cslflemalle.be',
    alias: 'csflemalle',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_DISON || 'kidsexplorers.be',
    alias: 'kidsexplorers',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_CSLIOLLN || 'csliolln.be',
    alias: 'csli-olln',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_LESSINESSPORT || 'lessinessport.be',
    alias: 'rcasl-lessines',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_SPORT1030 || 'sport1030.brussels',
    alias: 'sport1030',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_VILLERSSPORTS || 'villers-sports.be',
    alias: 'rca-villers-la-ville',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_HANNUT || 'sport.hannut.be',
    alias: 'rca-hannut',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_AWAILLE || 'rca-aywaille.be',
    alias: 'rca-aywaille',
  },
  {
    domain: process.env.VUE_APP_DOMAIN_MAPPING_AWAILLE || 'royaletrierbelge.be',
    alias: 'royal-etrier-belge',
  },
];
export const mainGlobalDomain = process.env.VUE_APP_CLIENT_DOMAIN;
export const globalDomains = [
  {
    domain: process.env.VUE_APP_CLIENT_DOMAIN || mainGlobalDomain,
    type: 'main_domain',
  },
  {
    domain: process.env.VUE_APP_CLIENT_CNAME || mainGlobalDomain,
    type: 'main_cname',
  },
  {
    domain: process.env.VUE_APP_CLIENT_SECOND_DOMAIN || mainGlobalDomain,
    type: 'second_domain',
  },
  {
    domain: process.env.VUE_APP_CLIENT_SECOND_CNAME || mainGlobalDomain,
    type: 'second_cname',
  },
];
